import { render, staticRenderFns } from "./DifferenceInMeans.vue?vue&type=template&id=49922151&scoped=true"
import script from "./DifferenceInMeans.vue?vue&type=script&lang=js"
export * from "./DifferenceInMeans.vue?vue&type=script&lang=js"
import style0 from "./DifferenceInMeans.vue?vue&type=style&index=0&id=49922151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49922151",
  null
  
)

export default component.exports